<div class="flex items-center justify-between">
  <h1
    class="pb-5 font-brand text-28px font-bold text-neutral-800"
    translate="zerosix.link-account.header"
  ></h1>
  <app-rounded-icon-button
    icon="icon-cross"
    (onClick)="onClose.emit($event)"
  ></app-rounded-icon-button>
</div>

<form>
  <app-kiosk-input-country-phone-atom
    id="zerosixRegistrationPhoneInput"
    [phone]="phone()"
    [useLocalFormat]="useLocalFormat()"
    [defaultRegionCode]="defaultRegionCode()"
    [helpTranslateKey]="'zerosix.help-phone-format'"
    (updatePhone)="phone.set($any($event))"
    (keydown)="handleKeyDown($event)"
  />

  <div class="">
    <app-numeric-keypad-atom
      (numberClick)="onKeypadNumberClick($event)"
      (deleteClick)="onKeypadDeleteClick()"
    ></app-numeric-keypad-atom>
  </div>

  @if (errorMessage) {
    <div
      class="mt-2 font-base text-xs font-normal text-error-700"
      [translate]="errorMessage"
    ></div>
  }

  <div class="mt-10 flex flex-col">
    <app-button-atom
      size="L"
      [label]="'zerosix.validate' | translate"
      [iconUrl]="isValidating ? 'assets/images/spinner.svg' : undefined"
      [disabled]="isValidating || !phone()"
      type="primary"
      [overrideTextColor]="accentColor?.font"
      [overrideBgColor]="accentColor?.background"
      [full]="true"
      (click)="onRegister()"
    ></app-button-atom>
  </div>
</form>
